import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../lib/constans';

export default function SocialAreas({ socialAreas }) {

    if (!Array.isArray(socialAreas) || socialAreas.length === 0) {
        console.warn("⚠️ No social areas data available");
        return (
            <div className="text-center p-8 text-white bg-gray-800 bg-opacity-50 rounded-lg m-4">
                <p className="text-lg">No hay información de áreas sociales disponible.</p>
            </div>
        );
    }

    const [activeAreaIndex, setActiveAreaIndex] = useState(0);
    const [currentImgIndex, setCurrentImgIndex] = useState(0);

    const currentArea = socialAreas[activeAreaIndex];
    const imagesList = currentArea?.images || [];

    useEffect(() => {
        setCurrentImgIndex(0);
    }, [activeAreaIndex]);

    const nextImage = () => {
        if (imagesList.length === 0) return;
        setCurrentImgIndex((prev) => (prev + 1) % imagesList.length);
    };

    const prevImage = () => {
        if (imagesList.length === 0) return;
        setCurrentImgIndex((prev) => (prev - 1 + imagesList.length) % imagesList.length);
    };

    return (
        <section className="w-full py-12 font-sans bg-p-beige">

            <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold tracking-wider text-p-blue inline-block relative pb-2 uppercase border-b-4 border-p-orange">
                    Onboard Areas & Social Spaces
                </h2>
            </div>
            <div className="relative w-full aspect-[5/6] md:aspect-[21/9] overflow-hidden shadow-xl bg-gray-900 group">
                <AnimatePresence mode="wait">
                    {imagesList.length > 0 && (
                        <motion.img
                            key={`${activeAreaIndex}-${currentImgIndex}`}
                            src={API_BASE_URL + imagesList[currentImgIndex]}
                            alt={currentArea.area}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.4 }}
                            className="w-full h-full object-cover"
                        />
                    )}
                </AnimatePresence>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none z-0" />
                {imagesList.length > 1 && (
                    <button
                        onClick={prevImage}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full transition-colors z-30 touch-manipulation"
                        aria-label="Previous image"
                    >
                        <LeftOutlined className="text-lg md:text-xl block" />
                    </button>
                )}

                {imagesList.length > 1 && (
                    <button
                        onClick={nextImage}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full transition-colors z-30 touch-manipulation"
                        aria-label="Next image"
                    >
                        <RightOutlined className="text-lg md:text-xl block" />
                    </button>
                )}

                <div className="absolute bottom-0 left-0 w-full grid grid-cols-2 md:grid-cols-4 gap-1 bg-black/60 backdrop-blur-xs border-t border-white/10 z-20">
                    {socialAreas.map((item, index) => {
                        const isActive = index === activeAreaIndex;
                        return (
                            <button
                                aria-label="Image group"
                                key={index}
                                onClick={() => setActiveAreaIndex(index)}
                                className={`relative py-3 px-2 text-center text-xs md:text-sm lg:text-base font-semibold tracking-wide uppercase transition-all duration-300 cursor-pointer touch-manipulation select-none
                                    ${isActive ? 'text-white bg-black/40 font-bold' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}
                            >
                                <span className="relative z-10 block truncate">{item.area}</span>
                                {isActive && (
                                    <motion.div
                                        layoutId="activeTabBorder"
                                        className="absolute bottom-0 left-0 right-0 h-1 bg-p-orange z-0"
                                        transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                                    />
                                )}
                            </button>
                        );
                    })}
                </div>

            </div>
        </section>
    );
}